<template>
  <table>
    <tbody>
      <extra-choice
        v-for="extra of extras"
        :key="extra.id"
        :extra="extra"
        :selected-counter="selectedExtras[extra.id]"
        @input="$emit('input', $event)"
      />
    </tbody>
  </table>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { Extra, SelectedExtras } from '../../schema'

@Component({
  emits: ['input'],
})
class ExtraChoices extends Vue {
  @Prop()
  extras: Extra[]

  @Prop()
  selectedExtras: SelectedExtras
}

export default toNative(ExtraChoices)
</script>
<style scoped>
td {
  vertical-align: middle;
}

.extra-name span {
  color: var(--colour-text-light);
  font-size: var(--body);
}

.extra-description {
  display: inline-block;
}
</style>
